import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../assets/logo.png';
import styles from './Footer.module.css';

function Footer() {
  const { i18n } = useTranslation();
  const isID = i18n.language === 'id';

  const navGroups = [
    {
      title: isID ? 'Kunjungi' : 'Navigation',
      links: [
        { href: '/landing', label: isID ? 'Beranda' : 'Home' },
        { href: '/public-info', label: isID ? 'Informasi GI' : 'GI Information' },
        { href: '/public-screening', label: isID ? 'Tes Skrining' : 'Screening Test' },
      ],
    },
    {
      title: isID ? 'Akun NOWGUT' : 'Account',
      links: [
        { href: '/login', label: isID ? 'Masuk' : 'Login' },
        { href: '/register', label: isID ? 'Daftar' : 'Register' },
      ],
    },
    {
      title: isID ? 'Tentang' : 'About',
      links: [
        { href: '/public-info', label: isID ? 'Tentang GI & ASD' : 'About GI & ASD' },
        { href: '/public-screening', label: isID ? 'Cara Penggunaan' : 'How to Use' },
      ],
    },

    {
      title: isID ? 'Tentang' : 'About',
      links: [
        { href: '/tentang', label: isID ? 'Tim NOWGUT' : 'Our Team' },
        { href: '/public-info', label: isID ? 'Tentang GI & ASD' : 'About GI & ASD' },
        { href: '/public-screening', label: isID ? 'Cara Penggunaan' : 'How to Use' },
      ],
    },
  ];

  return (
    <footer className={styles.footer}>
      {/* ===== NAVIGATION ===== */}
      <div className={styles.nav}>
        <div className={styles.navInner}>
          <div>
            <div className={styles.brandRow}>
              <img src={logo} alt="" />
              <div>
                <div className={styles.brandName}>NOWGUT</div>
                <div className={styles.brandTagline}>
                  {isID ? 'Pemantau Risiko GI Anak' : 'Child GI Risk Monitor'}
                </div>
              </div>
            </div>
            <p className={styles.brandDesc}>
              {isID
                ? 'Platform pemantauan kesehatan gastrointestinal berbasis bukti ilmiah untuk caregiver anak dengan ASD.'
                : 'An evidence-based GI monitoring platform for caregivers of children with ASD.'}
            </p>
          </div>
          {navGroups.map((group, i) => (
            <div key={i}>
              <div className={styles.navTitle}>{group.title}</div>
              <div className={styles.navLinks}>
                {group.links.map((link, j) => (
                  <Link key={j} to={link.href} className={styles.navLink}>
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ===== BOTTOM ===== */}
      <div className={styles.divider} />
      <div className={styles.bottom}>
        <div className={styles.bottomInner}>
          <p className={styles.copyright}>
            © {new Date().getFullYear()} NOWGUT. {isID ? 'Hak cipta dilindungi.' : 'All rights reserved.'}
          </p>
          <p className={styles.disclaimer}>
            {isID
              ? 'Bukan pengganti diagnosis medis. Selalu konsultasikan dengan dokter.'
              : 'Not a substitute for medical diagnosis. Always consult a doctor.'}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;